/**
 * ***************************
 * Overview Components in Discovery Tool *
 * ***************************
 */
const DiscoveryOverview = () => import('@/components/Discovery/Overview');
const OverviewCurrent = () => import('@/components/Discovery/OverviewCurrent');

export default {
  title: 'Overview',
  link: '/discovery/overview',
  path: 'overview',
  redirect: '/discovery/overview/current',
  component: DiscoveryOverview,
  permission: [
    {
      action: 'view',
      entity: 'discovery_project'
    }
  ],
  meta: {
    id: 'discovery__overview-tab'
  },
  children: [
    {
      path: 'current',
      component: OverviewCurrent,
      props: {
        type: 'current'
      },
      meta: {
        permission: [
          {
            action: 'view',
            entity: 'discovery_project'
          }
        ],
        id: 'discovery__current-tab'
      }
    },
    {
      path: 'archived',
      component: OverviewCurrent,
      props: {
        type: 'archived'
      },
      meta: {
        permission: [
          {
            action: 'view',
            entity: 'discovery_project'
          }
        ],
        id: 'discovery__archived-tab'
      }
    }
  ]
};
